// extracted by mini-css-extract-plugin
module.exports = {"dot":"ValidationListItem_dot__2trus","itemValid":"ValidationListItem_itemValid__2yLZH","text":"ValidationListItem_text__2JYdh"};